module.exports = __webpack_public_path__ + "img/logo.767aafd8.png";